import { actionIconProps } from './action-icon/action-icon-props';
import { anchorProps } from './anchor/anchor-props';
import { autocompleteProps } from './input/autocomplete/autocomplete-props';
import { badgeComponent } from './badge/badge.component';
import { breadcrumbsProps } from './breadcrumbs/breadcrumbs-props';
import { buttonProps } from './button/button-props';
import { calendarProps } from './datetime/calendar/calendar-props';
import { cardProps } from './card/card-props';
import { checkboxProps } from './checkbox/checkbox-props';
import { colors } from './colors/colors';
import { containerProps } from './container/container-props';
import { dateInputProps } from './datetime/date-input/date-input-props';
import { datePickerInputProps } from './datetime/date-picker-input/date-picker-input-props';
import { datePickerProps } from './datetime/date-picker/date-picker-props';
import { dateTimePickerProps } from './datetime/datetime-picker/datetime-picker-props';
import { fontsProps } from './fonts';
import { inputDescriptionProps } from './input/description/input-description-props';
import { inputErrorProps } from './input/error/input-error-props';
import { inputWrapperProps } from './input/wrapper/input-wrapper-props';
import { loaderProps } from './loader/loader-props';
import { createTheme } from '@mantine/core';
import { modalProps } from './modal/modal-props';
import { monthPickerInputProps } from './datetime/month-picker-input/month-picker-input-props';
import { monthPickerProps } from './datetime/month-picker/month-picker-props';
import { multiselectProps } from './input/multiselect/multiselect-props';
import { notificationProps } from './notification/notification-props';
import { numberInputProps } from './input/number-input/number-input-props';
import { paginationProps } from './pagination/pagination-props';
import { radioProps } from './radio/radio-props';
import { segmentedControlProps } from './segmented-control/segmented-control-props';
import { selectProps } from './input/select/select-props';
import { stepperProps } from './stepper/stepper-props';
import { switchProps } from './switch/switch-props';
import { tabsProps } from './tabs/tabs-props';
import { tagsInputProps } from './input/tagsinput/tagsinput-props';
import { textAreaProps } from './input/textarea/textarea-props';
import { textInputProps } from './input/textinput/text-input-props';
import { timeInputProps } from './datetime/time-input/time-input-props';
import { variantColorResolver } from './colors/variant-colors';
import { yearPickerInputProps } from './datetime/year-picker-input/year-picker-input-props';
import { yearPickerProps } from './datetime/year-picker/year-picker-props';
import activeClasses from './common/active.module.css';
import focusClasses from './common/focus.module.css';
import './colors/colors.module.css';
export const goodTheme = createTheme({
    focusRing: 'always',
    variantColorResolver,
    focusClassName: focusClasses['focus-auto'],
    activeClassName: activeClasses.active,
    defaultRadius: 6,
    colors,
    primaryColor: 'ocean',
    ...fontsProps,
    components: {
        ...modalProps,
        ActionIcon: actionIconProps,
        Anchor: anchorProps,
        Autocomplete: autocompleteProps,
        Breadcrumbs: breadcrumbsProps,
        Badge: badgeComponent,
        Button: buttonProps,
        Calendar: calendarProps,
        Card: cardProps,
        Checkbox: checkboxProps,
        Container: containerProps,
        DateInput: dateInputProps,
        DatePicker: datePickerProps,
        DatePickerInput: datePickerInputProps,
        DateTimePicker: dateTimePickerProps,
        InputDescription: inputDescriptionProps,
        InputError: inputErrorProps,
        InputWrapper: inputWrapperProps,
        Loader: loaderProps,
        MonthPicker: monthPickerProps,
        MonthPickerInput: monthPickerInputProps,
        MultiSelect: multiselectProps,
        Notification: notificationProps,
        NumberInput: numberInputProps,
        Pagination: paginationProps,
        Radio: radioProps,
        SegmentedControl: segmentedControlProps,
        Select: selectProps,
        Stepper: stepperProps,
        Switch: switchProps,
        Tabs: tabsProps,
        TagsInput: tagsInputProps,
        Textarea: textAreaProps,
        TextInput: textInputProps,
        TimeInput: timeInputProps,
        YearPicker: yearPickerProps,
        YearPickerInput: yearPickerInputProps,
    },
});
